// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"fd916b39","343":"1fb5987c"}[chunkId] + ".chunk.js";
};